import React from 'react'

function Attribution() {
    return (
        <div class="attribution">
            Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank">Frontend Mentor</a>.
            Coded by <a href="https://www.github.com/phmac7/phmac7" target="_blank">Pedro Machado</a>.
        </div>
    )
}

export default Attribution